<template>
	<v-container class="project-page none-fluid mx-auto link">
		<h1 class="text-center" v-html="title"></h1>
		<br />
		<p v-if="content" v-html="$sanitize(content)"></p>
		<br />
		<div v-if="videos.length">
			<h2>Videos</h2>
				<div v-for="(video, i) in videos" :key="video">
					<div v-html="video" class="videos-container"></div>
					<p class="text-center" v-html="$sanitize(videoCaptions[i])"></p>
				</div>
			<br />
		</div>
		<div v-if="images.length">
			<h2>Images</h2>
			<div class="project-page-images">
				<div v-for="(image, i) in images" :key="image">
					<img :src="image" alt="image" class="mx-auto" />
					<p class="text-center" v-html="$sanitize(imageCaptions[i])"></p>
				</div>
			</div>
			<br />
		</div>
		<div v-if="relatedProjects.length">
			<h2>Related Projects</h2>
			<div v-for="proj in relatedProjects" :key="proj" v-html="$sanitize(proj)"></div>
			<br />
		</div>
		<div v-if="relatedPastProjects.length">
			<h2>Related Past Projects</h2>
			<div v-for="proj in relatedPastProjects" :key="proj" v-html="$sanitize(proj)"></div>
			<br />
		</div>
		<div v-if="posters.length">
			<h2>NRI PI Meeting Posters</h2>
			<ul>
				<li v-for="(poster, i) in posters" :key="i" v-html="$sanitize(poster)"></li>
			</ul>
			<br />
		</div>
		<div v-if="publications.length">
			<h2>Publications</h2>
			<ul>
				<li v-for="publication in publications" :key="publication" v-html="$sanitize(publication)"></li>
			</ul>
			<br />
		</div>
		<div v-if="awards.length">
			<h2>Awards</h2>
			<ul>
				<li v-for="award in awards" :key="award" v-html="$sanitize(award)"></li>
			</ul>
			<br />
		</div>
		<div v-if="support.length">
			<h2>Support</h2>
			<p v-html="$sanitize(support)"></p>
			<br />
		</div>
		<div v-if="Array.isArray(people) && people.length">
			<h2>People</h2>
			<div v-for="person in people" :key="person" v-html="$sanitize(person)"></div>
			<br />
		</div>
		<div v-else-if="Object.keys(people).length">
			<h2>People</h2>
			<div v-if="people.main" class="category-box">
				<div v-for="person in people.main" :key="person" v-html="$sanitize(person)"></div>
			</div>
			<div v-if="people.master" class="category-box">
				<span class="category-text">MS Students</span>
				<div v-for="person in people.master" :key="person" v-html="$sanitize(person)"></div>
			</div>
			<div v-if="people.undergrad" class="category-box">
				<span class="category-text">Undergraduate Students</span>
				<div v-for="person in people.undergrad" :key="person" v-html="$sanitize(person)"></div>
			</div>
			<div v-if="people.highschool" class="category-box">
				<span class="category-text">High School Students</span>
				<div v-for="person in people.highschool" :key="person" v-html="$sanitize(person)"></div>
			</div>
		</div>
		<div v-if="Array.isArray(pastPeople) && pastPeople.length">
			<h2>Past People</h2>
			<div v-for="person in pastPeople" :key="person" v-html="$sanitize(person)"></div>
			<br />
		</div>
		<div v-else-if="Object.keys(pastPeople).length">
			<h2>Past People</h2>
			<div v-if="pastPeople.main" class="category-box">
				<div v-for="person in pastPeople.main" :key="person" v-html="$sanitize(person)"></div>
			</div>
			<div v-if="pastPeople.master" class="category-box">
				<span class="category-text">MS Students</span>
				<div v-for="person in pastPeople.master" :key="person" v-html="$sanitize(person)"></div>
			</div>
			<div v-if="pastPeople.undergrad" class="category-box">
				<span class="category-text">Undergraduate Students</span>
				<div v-for="person in pastPeople.undergrad" :key="person" v-html="$sanitize(person)"></div>
			</div>
			<div v-if="pastPeople.highschool" class="category-box">
				<span class="category-text">High School Students</span>
				<div v-for="person in pastPeople.highschool" :key="person" v-html="$sanitize(person)"></div>
			</div>
		</div>
		<div v-if="participantRecruting.length">
			<h2>Study Participant Recruiting</h2>
			<p v-html="$sanitize(participantRecruting)"></p>
			<br />
		</div>
	</v-container>
</template>

<script>
import { getProjectById } from "../../service/research/projects";

export default {
	data() {
		return {
			title: "",
			content: "",
			images: [],
			imageCaptions: [],
			publications: [],
			support: "",
			people: [],
			pastPeople: [],
			relatedProjects: [],
			relatedPastProjects: [],
			posters: [],
			videos: [],
			videoCaptions: [],
			participantRecruting: "",
			awards: []
		};
	},
	mounted() {
		if(this.$route.query.id){
			this.$router.replace({ name: 'project page', params: { id: this.$route.query.id }})
		}

		const id = this.$route.params.id;
		getProjectById(id)
			.then(data => {
				const {
					title,
					content,
					images,
					imageCaptions,
					publications,
					support,
					people,
					pastPeople,
					relatedProjects,
					relatedPastProjects,
					posters,
					videos,
					videoCaptions,
					participantRecruting,
					awards
				} = data;
				this.title = title;
				this.images = images;
				this.content = content;
				this.imageCaptions = imageCaptions;
				this.publications = publications.reverse();
				this.support = support;
				this.people = people;
				this.pastPeople = pastPeople;
				this.relatedProjects = relatedProjects;
				this.relatedPastProjects = relatedPastProjects;
				this.posters = posters.reverse();
				this.videos = videos;
				this.videoCaptions = videoCaptions;
				this.participantRecruting = participantRecruting;
				this.awards = awards;
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style lang="scss" scoped>
.project-page {
	h2 {
		margin-bottom: 10px;
	}

	a {
		display: inline-block;
	}

	.project-page-images {
		img {
			display: block;
			max-height: 500px;
			max-width: 100%;
			margin: 20px;
		}
	}

	.category-box {
		margin-bottom: 10px;
	}

	.category-box span {
		text-decoration: underline;
	}

	.videos-container > * {
		display: block;
		margin: 0 auto;
	}
}
</style>